<mat-card appearance="outlined">
  <mat-card-content>
    <mat-form-field *ngIf="filter">
      <input matInput autocomplete="off" placeholder="Filter" [formControl]="filter" i18n-placeholder />
    </mat-form-field>
    <mat-selection-list cdkDropList
                        [cdkDropListDisabled]="!isReorderingSupported()"
                        (cdkDropListDropped)="onDrop($event)"
                        (selectionChange)="onSelectionChange($event)">
      <div *ngFor="let group of list.visibleGroups">
        <h3 matSubheader *ngIf="list.style === SelectableListStyle.Grouped">{{ group.title }}</h3>
        <mat-divider></mat-divider>
        <mat-list-option cdkDrag
                         *ngFor="let item of group.items"
                         [checkboxPosition]="before"
                         [selected]="list.isSelected(item)"
                         [value]="item.id">
          <div class="title" matListItemTitle>{{ item.title }}</div>
          <div matListItemLine>{{ item.subtitle }}</div>
        </mat-list-option>
      </div>
      <mat-list-item *ngIf="list.visibleItems.length === 0" i18n>No items satisfy filter...</mat-list-item>
    </mat-selection-list>
  </mat-card-content>
</mat-card>
